import { useSession } from "next-auth/react";
import { type FC } from "react";
import { SimpleArticleCard } from "@src/component/card";
import { SimpleArticleCardLoading } from "@src/component/loading";
import { NoArticlesUploadedError } from "@src/component/miniComponent";
// import { AuthorArea } from "~/pages/dev/[username]";
import { type LayoutProps } from "./Stacked";
import { useSupabaseAuth } from "@src/utils/SupabaseAuthContext";
import { AuthorArea } from "@src/component/pages/userDomain";
// import { AuthorArea } from "~/pages/user-domain/[domain]";

const Grid: FC<LayoutProps> = (({ data, isLoading, author }) => {
  // const { data: user } = useSession();

  const { user } = useSupabaseAuth()

  return (
    <div className="w-full bg-light-bg dark:bg-primary">
      <AuthorArea author={author} />

      {isLoading ? (
        <div className="border-light h-[50%] min-h-[24rem] rounded-md border border-border-light bg-gray-200 shadow-md dark:border-border dark:bg-primary-light"></div>
      ) : data && data.length > 0 ? (
        <div className="border-t border-border-light dark:border-border">
          <div className="mx-auto flex max-w-[1000px] flex-wrap gap-4 px-4 py-4 sm:py-8">
            {data.map((e) => (
              <SimpleArticleCard key={e.id} article={e} />
            ))}
            {
              isLoading && (
                <>
                  <SimpleArticleCardLoading number={3} />
                  <SimpleArticleCardLoading number={3} />
                  <SimpleArticleCardLoading number={3} />
                  <SimpleArticleCardLoading number={3} />
                  <SimpleArticleCardLoading number={3} />
                  <SimpleArticleCardLoading number={3} />
                  <SimpleArticleCardLoading number={3} />
                  <SimpleArticleCardLoading number={3} />
                </>
              )
            }
          </div>
        </div>
      ) : (
        <NoArticlesUploadedError user={user} author={author} />
      )}
    </div>
  );
});

export default Grid;
